const JD_SOURCE_TYPE_LABELS = {
  AI_GENERATED: 'AI Generated',
  FILE_UPLOAD: 'Uploaded',
  UPLOADED: 'Uploaded',
  MANUAL_EDIT: 'Edited',
  CEIPAL_IMPORT: 'Ceipal Import',
  // Legacy/default attach type — first-version craft JDs use this when sourceType is omitted
  ATTACHED: 'AI Generated',
  WHATSAPP_ATTACHMENT: 'WhatsApp',
  UNKNOWN: 'AI Generated',
};

function normalizeSourceTypeKey(value) {
  return String(value || '').trim().toUpperCase().replace(/[\s-]+/g, '_');
}

function humanizeSourceType(key) {
  return key
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
}

function resolveAiGeneratedFlag(jd) {
  const value = jd.isAiGenerated ?? jd.aiGenerated ?? jd.is_ai_generated;
  return value === true || value === 'true';
}

/** Find a JD version by id (handles string/number mismatches from API vs UI state). */
export function findJdById(jdVersions, jdId) {
  if (jdId == null || !Array.isArray(jdVersions)) return null;
  return (
    jdVersions.find(
      (jd) =>
        jd.jdId === jdId ||
        jd.jdId === parseInt(jdId, 10) ||
        String(jd.jdId) === String(jdId)
    ) || null
  );
}

/** Resolve a user-facing label for a JD version (source type / AI flag). */
export function getJdSourceTypeLabel(jd) {
  if (!jd) return 'Unknown';

  const raw = jd.sourceType ?? jd.source_type ?? '';
  const key = normalizeSourceTypeKey(raw);

  if (key && JD_SOURCE_TYPE_LABELS[key]) {
    return JD_SOURCE_TYPE_LABELS[key];
  }

  if (resolveAiGeneratedFlag(jd)) {
    return 'AI Generated';
  }

  if (key) {
    const humanized = humanizeSourceType(key);
    if (humanized.toLowerCase() === 'unknown') {
      return 'AI Generated';
    }
    return humanized;
  }

  // Legacy rows: no sourceType — version 1 craft JDs are almost always AI-generated
  if (jd.version === 1 || jd.version === '1') {
    return 'AI Generated';
  }

  return 'Edited';
}
